import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogged: false,
    user: null,
    convocation_form:null,
    edition_id: null,
    edition: null,
    drawer:false,
    currentRouteName:null,

    current_edition_id:null,
    current_tab:null,

    current_type_tab:0,

    state_convocation_form:null,

    currentEdition:null,
    currentTab:'tab-list',

    currentTypeTab:0,
    entrepreneurships_edition_tab: 2
  },
  mutations: {
    setUserData (state, userData) {
      // state.isLogged = true
      // state.drawer = true
      state.user = userData
      localStorage.setItem('user', JSON.stringify(userData))
      axios.defaults.headers.common.Authorization = `Bearer ${userData.access_token}`
    },

    setIsLogged(state, isLoggedData) {
      state.isLogged = isLoggedData
    },

    setConvocationForm (state, convocation_form_Data) {
      state.convocation_form = convocation_form_Data
      localStorage.setItem('convocation_form', JSON.stringify(convocation_form_Data))
    },

    setEditionId (state, edition_id) {
      state.edition_id = edition_id
      localStorage.setItem('edition_id', edition_id)
    },

    setEdition (state, edition_Data) {
      state.edition = edition_Data
      localStorage.setItem('edition', JSON.stringify(edition_Data))
    },

    getUserData () { 
      const userData = localStorage.getItem('user')
      if (userData) {
        return JSON.parse(userData)
      }
      return null
    },

    getConvocationFormData () { 
      const convocation_form_Data = localStorage.getItem('convocation_form')
      if (convocation_form_Data) {
        return JSON.parse(convocation_form_Data)
      }
      return null
    },

    getEditionData () { 
      const edition_Data = localStorage.getItem('edition')
      if (edition_Data) {
        return JSON.parse(edition_Data)
      }
      return null
    },

    clearUserData () {
      localStorage.removeItem('user')
      localStorage.removeItem('convocation_form')
      localStorage.removeItem('edition')

      localStorage.clear();
      
      this.state.isLogged= false
    },

    setDrawer (state, drawer) {
      state.drawer = drawer
    },

    setCurrentRouteName  (state, currentRouteName) {
      state.currentRouteName = currentRouteName
    },

    setCurrentEditionId  (state, current_edition_id) {
      state.current_edition_id = current_edition_id
    },

    setCurrentTab  (state, current_tab) {
      state.current_tab = current_tab
    },

    setCurrentTypeTab  (state, current_type_tab) {
      state.current_type_tab = current_type_tab
    },

    setEntrepreneurshipsEditionTab(state, tab) {
      state.entrepreneurships_edition_tab = tab
    }

  },
  actions: {
    async register ({ commit }, credentials) {
      return axios
        .post('/register', credentials)
        .then(({ data }) => {
          commit('setUserData', data)
          this.drawer=true
        })
    },

    async login ({ commit }, credentials) {
      return axios
        .post('/login', credentials)
        .then(({ data }) => {
          commit('setUserData', data)
          // this.drawer=true
        })
    },

    Logged ({ commit }, is_logged) {
      commit('setIsLogged',is_logged)
    },

    convocationForm ({ commit }, convocation_form) {
      commit('setConvocationForm',convocation_form)
    },

    edition_id ({ commit }, edition_id) {
      commit('setEditionId',edition_id)
    },

    edition ({ commit }, edition) {
      commit('setEdition',edition)
    },

    logout ({ commit }) {
      commit('clearUserData')
      this.drawer=false
    },

    setDrawer({ commit }, drawer) {
      commit('setDrawer', drawer);
    },
  },
  getters: {
    isLogged: state => state.isLogged,
    drawer: state => state.drawer,
    user: state => state.user,
    convocation_form: state => state.convocation_form,
    edition_id: state => state.edition_id,
    edition: state => state.edition,

    currentEdition: state => state.currentEdition,
    currentTab: state => state.currentTab,

    currentTypeTab: state => state.currentTypeTab
  }
})